import { useCallback } from 'react';
import { manageAutoFunding } from '../../../../../wallet/utilities/api';

export const useWalletSaveAutoFunding = (walletId) => {
  return useCallback(
    (config) => {
      return manageAutoFunding(walletId, config);
    },
    [walletId],
  );
};
